$(document).ready(function(){
;(function ($, window, document, undefined) {
    Owl2row = function (scope) {
        this.owl = scope;
        this.owl.options = $.extend({}, Owl2row.Defaults, this.owl.options);
        //link callback events with owl carousel here

        this.handlers = {
            'initialize.owl.carousel': $.proxy(function (e) {
                if (this.owl.settings.owl2row) {
                    this.build2row(this);
                }
            }, this)
        };

        this.owl.$element.on(this.handlers);
    };

    Owl2row.Defaults = {
        owl2row: false,
        owl2rowTarget: 'item',
        owl2rowContainer: 'owl2row-item',
        owl2rowDirection: 'utd' // ltr
    };

    //mehtods:
    Owl2row.prototype.build2row = function(thisScope){
    
        var carousel = $(thisScope.owl.$element);
        var carouselItems = carousel.find('.' + thisScope.owl.options.owl2rowTarget);

        var aEvenElements = [];
        var aOddElements = [];

        $.each(carouselItems, function (index, item) {
            if ( index % 2 === 0 ) {
                aEvenElements.push(item);
            } else {
                aOddElements.push(item);
            }
        });

        carousel.empty();

        switch (thisScope.owl.options.owl2rowDirection) {
            case 'ltr':
                thisScope.leftToright(thisScope, carousel, carouselItems);
                break;

            default :
                thisScope.upTodown(thisScope, aEvenElements, aOddElements, carousel);
        }

    };

    Owl2row.prototype.leftToright = function(thisScope, carousel, carouselItems){

        var o2wContainerClass = thisScope.owl.options.owl2rowContainer;
        var owlMargin = thisScope.owl.options.margin;

        var carouselItemsLength = carouselItems.length;

        var firsArr = [];
        var secondArr = [];

        //console.log(carouselItemsLength);

        if (carouselItemsLength %2 === 1) {
            carouselItemsLength = ((carouselItemsLength - 1)/2) + 1;
        } else {
            carouselItemsLength = carouselItemsLength/2;
        }

        //console.log(carouselItemsLength);

        $.each(carouselItems, function (index, item) {


            if (index < carouselItemsLength) {
                firsArr.push(item);
            } else {
                secondArr.push(item);
            }
        });

        $.each(firsArr, function (index, item) {
            var rowContainer = $('<div class="' + o2wContainerClass + '"/>');

            var firstRowElement = firsArr[index];
                firstRowElement.style.marginBottom = owlMargin + 'px';

            rowContainer
                .append(firstRowElement)
                .append(secondArr[index]);

            carousel.append(rowContainer);
        });

    };

    Owl2row.prototype.upTodown = function(thisScope, aEvenElements, aOddElements, carousel){

        var o2wContainerClass = thisScope.owl.options.owl2rowContainer;
        var owlMargin = thisScope.owl.options.margin;

        $.each(aEvenElements, function (index, item) {

            var rowContainer = $('<div class="' + o2wContainerClass + '"/>');
            var evenElement = aEvenElements[index];

            evenElement.style.marginBottom = owlMargin + 'px';

            rowContainer
                .append(evenElement)
                .append(aOddElements[index]);

            carousel.append(rowContainer);
        });
    };

    /**
     * Destroys the plugin.
     */
    Owl2row.prototype.destroy = function() {
        var handler, property;

        for (handler in this.handlers) {
            this.owl.dom.$el.off(handler, this.handlers[handler]);
        }
        for (property in Object.getOwnPropertyNames(this)) {
            typeof this[property] !== 'function' && (this[property] = null);
        }
    };

    $.fn.owlCarousel.Constructor.Plugins['owl2row'] = Owl2row;
})( window.Zepto || window.jQuery, window,  document );
//end of owl2row plugin

//init carousel
  $('.list-collection-item').owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    owl2row: true,
    dots : false,
    responsive: {
        0: {
            items: 3,
            nav: false,
            loop:false,
            center: false,
            margin: 0,
            stagePadding: 0
        },
        600: {
            items: 2
        },
        900: {
            items: 3
        },
        1281: {
            items: 4
        }
    }
  });
  $('.first_logo_section').owlCarousel({
    loop: false,
    owl2row: true,
    margin: 30,
    nav: true,
    dots : false,
    responsive: {
        0: {
            items: 3,
            nav: false,
            loop:false,
            center: false,
            margin: 10,
            stagePadding: 10
        },
        600: {
            items: 4
        },
        1000: {
            items: 5
        }
    }
  });  
});
$('body').on('click', '.ShowPickupAvailabilityDrawer', function() {
   $('#ShowPickupAvailabilityDrawer').trigger('click');
});
$('body.template_product').on('change', '.popup-variant-option .popup-select__select', function() {
   var get_variant_ID = $(this).find(":selected").attr('id'); 
   var get_variant_Value = $(this).find(":selected").attr('value'); 
   var get_qty = $(this).find(":selected").attr('qty');
   if(get_qty == 0 || get_qty < 0){
    $(this).siblings('.popup-add-cart').text('Sold Out');
    $(this).siblings('.popup-add-cart').addClass('disabled');
   }
   else if(get_qty > 0){
     $(this).siblings('.popup-add-cart').text('Add');
     $(this).siblings('.popup-add-cart').attr('product_id', get_variant_ID);
     $(this).siblings('.popup-add-cart').attr('variant_title', get_variant_Value);
     $(this).siblings('.popup-add-cart').removeClass('disabled');
     $(this).siblings('.popup-add-cart').addClass('option-add-btn');
   }
});
$('body').on('click', '#CartDrawer-Overlay', function(e) {
  if ($(this).closest('.drawer').hasClass('active')) {
    $('.drawer').removeClass('active');
    $('body').removeClass('overflow-hidden');
  }
});